import { EdgeProps } from '@xyflow/react';
import { memo } from 'react';
import { skyDark } from '../../../styles/design-tokens';
import { SmartBezierEdge } from './SmartBezierEdge';

export const BackwardsEventEdge = memo(
  ({
    source,
    target,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    data,
    id,
    markerEnd,
    markerStart,
  }: EdgeProps) => {
    const edgeData = data as {
      weight: number;
      task_count: number;
      cycle_time: number;
      percentage: number;
      cost: number;
      viewType: string;
      dashed: boolean;
      isRightGraph: boolean;
    };
    const safeWeight = edgeData?.weight && edgeData.weight > 1 ? edgeData.weight : 1;
    const strokeWidth = Math.max(1.5, Math.min(Math.log(safeWeight) * 1.2, 6));

    // Custom edge style with the calculated color and width
    const edgeStyle = {
      stroke: skyDark,
      strokeWidth,
      strokeLinecap: 'round' as const,
      strokeDasharray: '5,5',
      ...style,
    };
    return (
      <SmartBezierEdge
        source={source}
        target={target}
        sourceX={sourceX}
        sourceY={sourceY}
        targetX={targetX}
        targetY={targetY}
        sourcePosition={sourcePosition}
        targetPosition={targetPosition}
        style={edgeStyle}
        data={data}
        id={id}
        markerEnd={markerEnd}
        markerStart={markerStart}
      />
    );
  },
);
